
<template>
  <div class="in-product-detail">
    <main class="main product-details-main">
      <PagesPath
        :pathTitle1="'محصولات'"
        :pathTo1="'/products'"
        :pathTitle2="product != null ? product.title : ''"
      ></PagesPath>
      <ProductContent :sets="productSets" v-model="product" />
      <!--      <ProductServices/>-->
      <section
        class="product-specifications-comments container   text-right mb-4 mb-sm-5"
      >
        <ul v-if="product != null" class="nav nav-tabs  py-4 px-1">
          <li
          v-if="
            product != null &&
              product.specifications &&
              product.specifications != ''
          "
          :class="activeTab === 'specifications' ? 'active' : ''"
        >
          <a
            class="px-sm-3 p-2 m-1 text-color-444 fontsize16 font-weight-bold"
            data-toggle="tab"
            :class="activeTab === 'specifications' ? 'active' : ''"
            @click="changeTab('specifications')"
          >
            مشخصات
          </a>
        </li>
          <li
            v-if="product != null && product.description"
            :class="activeTab === 'review' ? 'active' : ''"
          >
            <a
              class="px-sm-3 p-2 m-1 text-color-444 fontsize16 font-weight-bold"
              data-toggle="tab"
              :class="activeTab === 'review' ? 'active' : ''"
              @click="changeTab('review')"
            >
              نقد بررسی
            </a>
          </li>
         
          <li :class="activeTab === 'comments' ? 'active' : ''">
            <a
              class="px-sm-3 p-2 m-1 text-color-444 fontsize16 font-weight-bold"
              data-toggle="tab"
              :class="activeTab === 'comments' ? 'active' : ''"
              @click="changeTab('comments')"
            >
              نظرات کاربران
            </a>
          </li>
        </ul>
        <ul v-else class="nav nav-tabs  py-4 px-1">
          <li class=" active">
            <a
              class="px-sm-3 p-2 m-1 text-color-444 fontsize14 font-weight-bold active"
              data-toggle="tab"
              href="#review"
            >
              نقد بررسی
            </a>
          </li>
        </ul>
        <div v-if="product != null && !product.isPreview" class="tab-content  ">
          <ProductReview :activeTab="activeTab" :product="product" />
          <ProductSpecifications
            v-if="product != null && product.specifications != ''"
            :activeTab="activeTab"
            :product="product"
          />
          <ProductComments :activeTab="activeTab" :product="product" />
        </div>
        <div v-else class="tab-content  ">
          <div id="review" class="tab-pane fade in active show">
            <p class="fontsize14 text-color-666 text-justify line-height2 p-3">
              <b-skeleton width="100%"></b-skeleton>
              <b-skeleton width="100%"></b-skeleton>
              <b-skeleton width="100%"></b-skeleton>
              <b-skeleton width="100%"></b-skeleton>
              <b-skeleton width="85%"></b-skeleton>
            </p>
          </div>
        </div>
      </section>
      <ProductSetSlider
        v-if="product && !product.isPreview"
        :sets="productSets"
      />
      <SimilarProducts
        v-if="product && !product.isPreview"
        :related="relatedProducts"
      />
      <ScrollToTop></ScrollToTop>
    </main>
    <Footer></Footer>
  </div>
</template>

<script>
import PagesPath from "@/parts/Front/components/PagesPath";
import ScrollToTop from "@/parts/Front/components/ScrollToTop";
import ProductServices from "@/parts/Front/components/productDetail/ProductServices";
import ProductComments from "@/parts/Front/components/productDetail/ProductComments";
import ProductSpecifications from "@/parts/Front/components/productDetail/ProductSpecifications";
import ProductSetSlider from "@/parts/Front/components/productDetail/ProductSetSlider";
import ProductReview from "@/parts/Front/components/productDetail/ProductReview";
import SimilarProducts from "@/parts/Front/components/productDetail/SimilarProducts";
import ProductContent from "@/parts/Front/components/productDetail/ProductContent";
import product from "@/parts/Front/components/productDetail/classes/product";
import ProductCongratulations from "@/parts/Front/components/productDetail/ProductCongratulations";
import config from "@/config";
import { BSkeleton } from "bootstrap-vue";

export default {
  name: "ProductDetails",
  components: {
    ProductCongratulations,
    ProductSetSlider,
    PagesPath,
    ScrollToTop,
    ProductServices,
    ProductComments,
    ProductSpecifications,
    ProductReview,
    SimilarProducts,
    ProductContent,
    BSkeleton,
  },
  computed: {
    getInitialProductInfo() {
      return this.$store.getters["front/getSavedProductInfo"];
    },
  },
  data() {
    return {
      url: "front/products/",
      title: "",
      disabled: false,
      relatedProducts: Array(5).fill(null),
      productSets: Array(5).fill(null),
      product: null,
      activeTab: "specifications"
    };
  },
  mounted() {
    // this.$store.dispatch('front/getProductDataFromServer', this.$route.params.id)
    if (this.$route.params.id) {
      this.getProduct(this.$route.params.id);
    }

    this.onResize();
    window.removeEventListener("resize", this.onResize);
    window.addEventListener("resize", this.onResize);
  },
  methods: {
    onResize() {
      const bodyWidth = document.body.offsetWidth;
      const colorChooseImg = document.querySelectorAll(".color-choose-img")[0];
      // const productDetContent=document.querySelectorAll('.product-details-content')[0];
      if (colorChooseImg) {
        if (bodyWidth < 767) {
          colorChooseImg.style.width = bodyWidth - 100 + "px";
        }
      }
    },
    changeTab(name) {
      // this.$store.commit('front/setProductActiveTab', name)
      this.activeTab =  name;
    },

    async getProduct(id) {
      this.disabled = true;
      try {
        if (this.getInitialProductInfo) {
          this.product = this.getInitialProductInfo;
        }
        const response = await this.$store.dispatch(
          "front/getProductFromServer",
          id
          );
        this.product = new product(response.data.data.product, this);
        this.relatedProducts = response.data.data.relatedProducts;
        this.productSets = response.data.data.settedProducts;
        if ( this.product.specifications != "") {
          this.activeTab = "specifications";


        } else if (
          this.product.description == null &&
          this.product.description != null
        ) {
          this.activeTab = "review";


        } else {
          this.activeTab = "comments";

        }
      } catch (error) {
        this.$root.errorNotify("محصول مورد نظر یافت نشد");
        this.$router.push("/");
      } finally {
        this.disabled = false;
      }
    },
  },
  metaInfo() {
    return {
      title: this.product
        ? config.title + ` - ${this.product.title}`
        : config.title,
      meta: [
        {
          name: "description",
          content: this.product
            ? this.product.meta_description
              ? this.product.meta_description
              : this.product.short_description
            : false,
        },
        {
          property: "og:title",
          content: this.product ? this.product.title : false,
        },
        { name: "robots", content: "index,follow" },
      ],
    };
  },
};
</script>

<style scoped>

.product-specifications-comments{
  margin-top: 5rem !important;
}
.nav-tabs{
  justify-content: center;
  gap: 2rem;
  border-bottom: unset;
}
.nav-tabs li a{
  position: relative;
  padding: 6px 2px !important;
}
.nav-tabs li a::before{
  content: "";
  position: absolute;
  width: 100%;
  height: 1px;
  background-color: #000;
  bottom: 0px;
  right: 0;
  transform: scaleX(0);
  transition: transform .3s;
  transform-origin: left;
}
.nav-tabs li a:not(.nav-tabs li a.active):hover:before{
  
  transform: scaleX(1);
  transform-origin: right;
}
.nav-tabs li a:not(.nav-tabs li a.active){
  color: gray;
  transform: scaleX(1);
  transform-origin: right;
}
.nav-tabs a.active{
  border-bottom: 1px solid #000;
}
.nav-tabs li:hover a.active{
  border-bottom: 1px solid #000;
}
</style>
